import { watch } from 'vue';
import { storeToRefs } from 'pinia';

import { useInternational } from '@/common/locale';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import {
  useSharedMenuSearchState,
  useMenuSearchNavigation,
  useMenuSearchResult,
} from '@/common/components/organisms/menuSearch/menuSearch.uses';
import { MenuSearchRecentItem } from '@/common/components/organisms/menuSearch/menuSearch.type';

export const setup = () => {
  const { t } = useInternational();

  const { isShowMenuSearch } = storeToRefs(useBaseMenuStore());

  const { menuSearchSelectedItemId } = useSharedMenuSearchState();
  const { menuSearchRecentItems } = useMenuSearchResult();
  const { handleEnter } = useMenuSearchNavigation();

  const handleClick = (item: MenuSearchRecentItem) => {
    handleEnter([item], () => {
      isShowMenuSearch.value = false;
    });
  };

  // menuSearchRecentItems가 로드되면 첫 번째 아이템 선택
  watch(
    menuSearchRecentItems,
    (newItems) => {
      if (newItems.length > 0 && !menuSearchSelectedItemId.value) {
        menuSearchSelectedItemId.value = newItems[0].id;
      }
    },
    { immediate: true },
  );

  return {
    t,
    menuSearchRecentItems,
    handleClick,
  };
};
